import { AxiosResponse } from "axios";
import { API } from "@/constants/api";
import { AxiosUtil } from "@/Utils/axios.util";
import { LoginForm } from "@/interfaces/auth/login-form.model";

// login admin
async function LoginAdmin(loginData: LoginForm): Promise<AxiosResponse> {
  const url = API.auth.loginUser;
  const body = {
    email: '0098' + loginData.mobile.slice(1),
    password: loginData.password
  }

  return await AxiosUtil.post(url, body);
}

export const authRequests = {
    LoginAdmin,
};
